import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-confirmation',
  templateUrl: './admin-confirmation.component.html',
  styleUrls: ['./admin-confirmation.component.scss']
})
export class AdminConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
